export const business_options = [{
  value: '01',
  label: '飲食関連サービス',
  children: [{
    value: '01',
    label: '宅配',
    children: [{
      value: '01',
      label: 'ピザ',
    }, {
      value: '02',
      label: '寿司',
    }, {
      value: '03',
      label: '弁当',
    }, {
      value: '99',
      label: 'その他'
    }]
  }, {
    value: '02',
    label: 'レストラン・カフェ',
  }, {
    value: '03',
    label: 'バー・ラウンジ',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '02',
  label: '住宅関連サービス',
  children: [{
    value: '01',
    label: '不動産',
  }, {
    value: '02',
    label: '住宅メーカー・工務店',
  }, {
    value: '03',
    label: 'リフォーム',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '03',
  label: '生活関連サービス',
  children: [{
    value: '01',
    label: '美容室',
  }, {
    value: '02',
    label: 'エステサロン',
  }, {
    value: '03',
    label: '美容整形',
  }, {
    value: '04',
    label: '整体・マッサージ',
  }, {
    value: '05',
    label: 'スポーツジム',
  }, {
    value: '06',
    label: '旅行代理店',
  }, {
    value: '07',
    label: '便利屋・リサイクル',
  }, {
    value: '08',
    label: '引っ越しサービス',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '04',
  label: '医療福祉関連サービス',
  children: [{
    value: '01',
    label: '介護・デイケア・老人ホーム',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '05',
  label: '情報通信関連サービス',
  children: [{
    value: '01',
    label: '携帯電話・インターネット',
  }, {
    value: '02',
    label: 'ケーブルテレビ',
  }, {
    value: '03',
    label: '新聞',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '06',
  label: '教育関連サービス',
  children: [{
    value: '01',
    label: '学習塾・習い事',
  }, {
    value: '02',
    label: '英会話',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '07',
  label: '卸・小売業',
  children: [{
    value: '01',
    label: 'コンビニ・スーパー',
  }, {
    value: '02',
    label: '通信販売',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '08',
  label: '金融・保険業',
  children: [{
    value: '01',
    label: '銀行・証券・保険',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '09',
  label: '広告業',
  children: [{
    value: '01',
    label: '広告代理店',
  }, {
    value: '99',
    label: 'その他',
  }]
},{
  value: '99',
  label: 'その他',
  children: [{
    value: '01',
    label: 'イベント・展示会',
  }, {
    value: '02',
    label: '選挙事務所',
  }, {
    value: '99',
    label: 'その他',
  }]
}]
